import React, { FunctionComponent } from 'react'
import { map, uniqueId } from 'lodash'
import accounting from 'accounting'
import classnames from 'classnames'

import { Loading } from '../../../components'
import { PaymentSummary } from '../../../typings/payments'

import styles from './styles.module.css'

interface SummaryProps {
  data: PaymentSummary
  isLoading: boolean
}

const Summary: FunctionComponent<SummaryProps> = ({ data, isLoading }) => {
  if (isLoading) {
    return (
      <div className={classnames(styles.stateContainer, styles.loading)}>
        <Loading />
      </div>
    )
  }

  return (
    <div className={styles.container}>
      {map(data, (section, name) => {
        const totalAmount = section.total || section || 0

        return (
          <div
            key={uniqueId('section-')}
            className={classnames(styles.section, {
              [styles.totalSection]: name === 'total',
            })}
          >
            <div className={styles.header}>
              <h4>{name}</h4>
              <span>{accounting.formatMoney(totalAmount, '$')}</span>
            </div>

            <div className={styles.breakdown}>
              {map(section.breakdown, ({ label, value }) => (
                <div
                  key={uniqueId('summary-breakdown-')}
                  className={styles.row}
                >
                  <span>{label}</span>
                  <span>{accounting.formatMoney(value || 0, '$')}</span>
                </div>
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default Summary
